import React from 'react';
import PropTypes from 'prop-types';

function GraphQueues (props) {
  const fontSizeInitials = parseInt(props.el.fontSizeInitials, 10) || 50;
  const fontSizeQueue = parseInt(props.el.fontSizeQueue, 10) || 50;
  const fontSizeNumber = parseInt(props.el.fontSizeNumber, 10) || 50;
  const fontSizeName = parseInt(props.el.fontSizeName, 10) || 50;
  const {
    members,
    typeDisplay,
    showInitials,
    showName,
    showNumber,
    configFields
  } = props.el;
  let reports = [];
  const rpts = props.reports.slice();

  if (typeDisplay && typeDisplay !== 'ALL' && members) {
    reports = rpts.filter(rpt => members.includes(rpt._id));
  } else {
    reports = [...rpts];
  }

  const groups = reports.reduce((result, group) => {
    const { _id, name, initials, number, queue } = group;
    if (Object.keys(result).includes(_id)) {
      result[_id].series.name = result[_id].series.name.concat([name]);
      result[_id].series.initials = result[_id].series.initials.concat([
        initials
      ]);
      result[_id].series.number = result[_id].series.number.concat([number]);
      result[_id].series.queue = result[_id].series.queue.concat([queue]);
    } else {
      result[_id] = {};
      result[_id].series = {
        name: [name],
        initials: [initials],
        number: [number],
        queue: [queue]
      };
    }
    return result;
  }, {});

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap'
      }}
    >
      {Object.keys(groups).map((_id, i) => {
        const { name, number, initials, queue } = groups[_id].series;
        let bgColor = '#ccc';

        try {
          if (configFields) {
            const config = configFields.find(config =>
              Object.keys(config).includes(_id)
            );
            if (config && config[_id]) {
              const {
                limit1Color,
                limit1Value,
                limit2Color,
                limit2Value,
                limit3Color,
                limit3Value
              } = config[_id];
              const limits = [
                { limit: limit1Value, color: limit1Color },
                { limit: limit2Value, color: limit2Color },
                { limit: limit3Value, color: limit3Color }
              ].sort((a, b) => {
                return String(a.limit).localeCompare(
                  String(b.limit),
                  undefined,
                  {
                    numeric: true,
                    sensitivity: 'base'
                  }
                );
              });

              const l1 = limits[0].limit;
              const l2 = limits[1].limit;
              const l3 = limits[2].limit;
              const c1 = limits[0].color;
              const c2 = limits[1].color;
              const c3 = limits[2].color;

              if (l1 !== l2 && l2 !== l3 && l3 !== l1) {
                const dataField = parseInt(queue, 10);
                if (dataField >= l3) {
                  bgColor = c3;
                } else if (dataField === l2) {
                  bgColor = c2;
                } else if (dataField === l1) {
                  bgColor = c1;
                } else if (dataField > l1 && dataField < l2) {
                  bgColor = c1;
                } else if (dataField > l2 && dataField < l3) {
                  bgColor = c2;
                }
              }
            }
          }
        } catch (err) {
          console.error(err);
        }

        return (
          <div key={i}>
            <div style={{ margin: '10px 10px 40px 10px' }}>
              {showInitials && (
                <span
                  className="d-block m-0 font-weight-bold text-center"
                  style={{
                    fontSize: `${fontSizeInitials}px`,
                    height: `${fontSizeInitials + fontSizeInitials * 0.3}px`
                  }}
                >
                  {initials}
                </span>
              )}
              <span className="d-block text-center">
                <span
                  className="m-0 rounded font-weight-bold"
                  style={{
                    backgroundColor: `${bgColor}`,
                    fontSize: `${fontSizeQueue}px`,
                    padding: `${fontSizeQueue * 0.2}px ${fontSizeQueue * 0.7}px`
                  }}
                >
                  {queue}
                </span>
              </span>
              {showNumber && (
                <span
                  className="d-block m-0 font-weight-bold text-center"
                  style={{
                    fontSize: `${fontSizeNumber}px`,
                    height: `${fontSizeNumber - fontSizeNumber * 0.01}px`
                  }}
                >
                  {number}
                </span>
              )}
              {showName && (
                <span
                  className="d-block m-0 text-center"
                  style={{
                    fontSize: `${fontSizeName}px`,
                    height: `${fontSizeName}px`,
                    color: '#696969'
                  }}
                >
                  {name}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default GraphQueues;

GraphQueues.propTypes = {
  el: PropTypes.object,
  reports: PropTypes.array
};
